// extracted by mini-css-extract-plugin
export default {"tabs_row":"UpdateAccount_tabs_row__6OFLS","active_tab":"UpdateAccount_active_tab__gfLcm"};